import {DateTime} from 'luxon';

export default function convertDatesFromUrlFilters(datesString: string): {
  startDate: DateTime;
  endDate: DateTime;
} {
  const [start, end] = datesString.replace(/[<>]/g, '').split('~');

  const startDate = DateTime.fromISO(start);
  const endDate = DateTime.fromISO(end);

  return {startDate, endDate};
}
